import { COMPANY_LIST, GET_COMPANY } from './types';
import {Api}from '../../components/Api';
import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
toast.configure();

export const companyList = () => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.get('/company/companies', {
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then((response) => {
                if (response.data.success) {
                    dispatch({
                        type: COMPANY_LIST,
                        payload: response.data.successResponse
                    })
                }
            }).catch(err => {
                if (err.response) {
                    const message = err.response.data.message;
                    if (typeof message === "string") {
                        toast.error(message);
                    }
                    console.log("Company List Error:", message);
                } else {
                    toast.error(err.message || "Failed to load companies.");
                }
            });
    }
}
export const addCompany = (data: any) => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.post('/company/add_company', data, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        })
            .then((response) => {
                if (response.data.success) {
                    toast.success(response.data.message || 'Company added successfully!');
                    setTimeout(() => {
                        window.location.href = "/companies";
                    }, 1500);
                }
            }).catch(err => {
                if (err.response) {
                    const message = err.response.data.message;
                    
                    // If message is an array of validation errors
                    if (Array.isArray(message)) {
                        message.forEach((msg) => {
                            // Clean up the message: remove underscores and capitalize
                            const cleanMsg = msg.replace(/_/g, " ");
                            toast.error(cleanMsg);
                        });
                    }
                    // If it's a single string error message
                    else if (typeof message === "string") {
                        toast.error(message);
                    }
                    // Fallback for other error types
                    else {
                        toast.error("Failed to add company. Please try again.");
                    }
                    
                    console.log("Add Company Error:", message);
                } else {
                    toast.error(err.message || "Network error. Please check your connection.");
                }
            });
    }
}
export const editCompany = (id: any, data: any) => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.put(`/company/edit_company/${id}`, data, {
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        })
            .then((response) => {
                if (response.data.success) {
                    toast.info(response.data.successResponse)
                    window.location.href = "/companies";
                }
            }).catch(err => {
                if (err.response) {
                    const message = err.response.data.message;
                    // If message is an array → show each error
                    if (Array.isArray(message)) {
                        message.forEach((msg) => toast.error(msg));
                    }
                    // If it's a single string → show once
                    else if (typeof message === "string") {
                        toast.error(message);
                    }
                    else {
                        toast.error("Something went wrong.");
                    }
    
                    console.log("Error:", message);
                } else {
                    toast.error(err.message);
                }
            });
    }
}
export const getCompany = (id: number) => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.get(`/company/company/${id}`, {
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then((response) => {
                if (response.data.success) {
                    dispatch({
                        type: GET_COMPANY,
                        payload: response.data.successResponse
                    })
                }
            }).catch(err => {
                if (err.response) {
                    const message = err.response.data.message;
                    if (typeof message === "string") {
                        toast.error(message);
                    }
                    console.log("Get Company Error:", message);
                } else {
                    toast.error(err.message || "Failed to load company details.");
                }
            });
    }
}
export const delCompany = (id: number) => {
    return function (dispatch: any) {
        let token: any = sessionStorage.getItem('token');
        Api.delete(`/company/del_company/${id}`, {
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then((response) => {
                if (response.data.success) {
                    toast.success(response.data.successResponse || 'Company deleted successfully!');
                    setTimeout(() => {
                        window.location.href = "/companies";
                    }, 1500);
                }
            }).catch(err => {
                if (err.response) {
                    const message = err.response.data.message;
                    
                    if (typeof message === "string") {
                        toast.error(message);
                    } else {
                        toast.error("Failed to delete company. Please try again.");
                    }
                    
                    console.log("Delete Company Error:", message);
                } else {
                    toast.error(err.message || "Network error. Please check your connection.");
                }
            });
    }
}